import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=2d8e207b"
import script from "./app-menu.vue?vue&type=script&lang=js"
export * from "./app-menu.vue?vue&type=script&lang=js"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=2d8e207b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports